import Cookies from 'js-cookie';
import { reactive } from 'vue';

type UserPreferences = {
    necessary: boolean;
    preferences: boolean;
    statistics: boolean;
    marketing: boolean;
  };

class CookieManager {

    private static instance: CookieManager; 

    private userPreferences = reactive<UserPreferences>({
        necessary: true,
        preferences: false,
        statistics: false,
        marketing: false,
      });

    private constructor() {
        this.userPreferences = {
            necessary: true,
            preferences: false,
            statistics: false,
            marketing: false,
        };
        this.getUserPreferences();
    }

    public static getInstance(): CookieManager {
        if (!CookieManager.instance) {
        CookieManager.instance = new CookieManager();
        }
        return CookieManager.instance;
    }

    public getUserPreferences(): UserPreferences {
        if (process.client) {
          const storedPreferences = localStorage.getItem('cookie-preferences');
          if (storedPreferences) {
            const preferences = JSON.parse(storedPreferences);
            for (const key in preferences) {
              if (key in this.userPreferences) {
                // TypeScript now knows that key is a valid key of UserPreferences
                this.userPreferences[key as keyof UserPreferences] = preferences[key];
              }
            }
          }
        }
        return this.userPreferences;
      }
      
      
    public setUserPreferences(preferences: object): void {
        if (process.client) {
            console.log('Setting cookie user preferences:', preferences);
            Object.assign(this.userPreferences, preferences);
            localStorage.setItem('cookie-preferences', JSON.stringify(this.userPreferences));
        }
    }

    public hasGivenConsent(): boolean {
        if (process.client) {
            return localStorage.getItem('cookie-preferences') !== null;
        }
        return false;
    }    

    private canSetCookie(type: string): boolean {
        console.log('Checking if cookie can be set:', type, this.userPreferences[type]);
        return this.userPreferences[type];
    }

    private setCookie(name: string, value: string, days: number, type: string): void {
        console.log('Trying to set cookie:', name, value, days, type);
        if (this.canSetCookie(type)) {
            Cookies.set(name, value, { expires: days });
        }
        else {
            console.log('Cookie not set, no allowance given', name, value, days, type);
        }
    }

    public setNecessaryCookie(name: string, value: string, days = 365): void {
        Cookies.set(name, value, { expires: days });
    }

    public setPreferenceCookie(name: string, value: string, days = 365): void {
        this.setCookie(name, value, days, 'preferences');
    }

    public getCookie(name: string): string | undefined {
        console.log('getCookie:', name, 'value:', Cookies.get(name));
        return Cookies.get(name);
    }

    public deleteCookie(name: string): void {
        Cookies.remove(name);
    }

    public loadScriptBasedOnPreference(type: string, scriptPath: string): void {
        if (this.canSetCookie(type)) {
            const script = document.createElement('script');
            script.src = scriptPath;
            document.head.appendChild(script);
        }
    }
}

export default CookieManager;